//#region src/index.ts
const HAVE_PERSONAL_ACCOUNT = "have-personal-account";
const AFFECT_TEAM = "affect-team";
const BE_AFFECTED = "be-affected";
const WRITE_GEAR_CATALOG = "write-gear-catalog";
const READ_GEAR_CATALOG = "read-gear-catalog";
const READ_SIGNAGE_CATALOG = "read-signage-catalog";
const WRITE_SIGNAGE_CATALOG = "write-signage-catalog";
const VIEW_GEAR_DASHBOARD = "view-gear-dashboard";
const VIEW_LOCATION = "view-location";
const MANAGE_LOCATION = "manage-location";
const READ_INVENTORY = "read-inventory";
const WRITE_INVENTORY = "write-inventory";
const MANAGE_PERSONAL_ACCOUNTS = "manage-personal-accounts";
const MANAGE_USERS = "manage-users";
const AFFECT_VOLUNTEER = "affect-volunteer";
const MANAGE_CONFIG = "manage-config";
const VALIDATE_FA = "validate-fa";
const VALIDATE_FT = "validate-ft";
const READ_ANIMATION_TO_PUBLISH = "read-animation-to-publish";
const READ_FA = "read-fa";
const WRITE_FA = "write-fa";
const READ_FT = "read-ft";
const WRITE_FT = "write-ft";
const FORCE_WRITE_FT = "force-write-ft";
const VIEW_FESTIVAL_EVENTS_STATS = "view-festival-events-stats";
const VIEW_TIMELINE = "view-timeline";
const ASK_FOR_HELP = "ask-for-help";
const VIEW_PLANNING = "view-planning";
const DOWNLOAD_PLANNING = "download-planning";
const SYNC_PLANNING = "sync-planning";
const VIEW_MULTI_PLANNING = "view-multi-planning";
const ENROLL_HARD = "enroll-hard";
const ENROLL_SOFT = "enroll-soft";
const VIEW_VOLUNTEER = "view-volunteer";
const VIEW_VOLUNTEER_DETAILS = "view-volunteer-details";
const SEND_MAIL_TEST = "send-mail-test";
const MANAGE_TEAMS = "manage-teams";
const MANAGE_PERMISSIONS = "manage-permissions";
const VIEW_DELETED_FT = "view-deleted-ft";
const MANAGE_ADMINS = "manage-admins";
const MANAGE_CONTRIBUTIONS = "manage-contributions";
const PAY_CONTRIBUTION = "pay-contribution";
const OFFER_SHARED_MEAL = "offer-shared-meal";
const SHOTGUN_SHARED_MEAL = "shotgun-shared-meal";
const MANAGE_SHARED_MEALS = "manage-shared-meals";
const BORROW_GEARS = "borrow-gears";
const MANAGE_CHARISMA_EVENTS = "manage-charisma-events";
const SET_FAVORITE_PAGES = "set-favorite-pages";
const VIEW_SECURITY_DASHBOARD = "view-security-dashboard";
const VIEW_FA_GEAR_DASHBOARD = "view-fa-gear-dashboard";
const VIEW_ORGA_MOBILE_NAV = "view-orga-mobile-nav";
const EXPORT_FOR_SIGNA = "export-for-signa";
const ENTER_EXTENDED_AVAILABILITITES = "enter-extended-availabilities";
const VIEW_USEFUL_LINKS = "view-useful-links";
const MUST_SIGN_VOLUNTEER_CHARTER = "must-sign-volunteer-charter";
const permissions = [
	HAVE_PERSONAL_ACCOUNT,
	AFFECT_TEAM,
	BE_AFFECTED,
	WRITE_GEAR_CATALOG,
	READ_GEAR_CATALOG,
	VIEW_GEAR_DASHBOARD,
	READ_SIGNAGE_CATALOG,
	WRITE_SIGNAGE_CATALOG,
	VIEW_LOCATION,
	READ_INVENTORY,
	WRITE_INVENTORY,
	MANAGE_PERSONAL_ACCOUNTS,
	MANAGE_USERS,
	AFFECT_VOLUNTEER,
	MANAGE_CONFIG,
	MANAGE_LOCATION,
	VALIDATE_FA,
	VALIDATE_FT,
	READ_ANIMATION_TO_PUBLISH,
	READ_FA,
	WRITE_FA,
	READ_FT,
	WRITE_FT,
	FORCE_WRITE_FT,
	VIEW_FESTIVAL_EVENTS_STATS,
	VIEW_TIMELINE,
	ASK_FOR_HELP,
	VIEW_PLANNING,
	DOWNLOAD_PLANNING,
	SYNC_PLANNING,
	VIEW_MULTI_PLANNING,
	ENROLL_HARD,
	ENROLL_SOFT,
	VIEW_VOLUNTEER,
	VIEW_VOLUNTEER_DETAILS,
	SEND_MAIL_TEST,
	MANAGE_TEAMS,
	MANAGE_PERMISSIONS,
	VIEW_DELETED_FT,
	MANAGE_ADMINS,
	MANAGE_CONTRIBUTIONS,
	PAY_CONTRIBUTION,
	OFFER_SHARED_MEAL,
	SHOTGUN_SHARED_MEAL,
	MANAGE_SHARED_MEALS,
	BORROW_GEARS,
	MANAGE_CHARISMA_EVENTS,
	SET_FAVORITE_PAGES,
	VIEW_SECURITY_DASHBOARD,
	VIEW_FA_GEAR_DASHBOARD,
	VIEW_ORGA_MOBILE_NAV,
	EXPORT_FOR_SIGNA,
	ENTER_EXTENDED_AVAILABILITITES,
	VIEW_USEFUL_LINKS,
	MUST_SIGN_VOLUNTEER_CHARTER
];
function isPermission(permission) {
	return permissions.some((p) => p === permission);
}
//#endregion
export { AFFECT_TEAM, AFFECT_VOLUNTEER, ASK_FOR_HELP, BE_AFFECTED, BORROW_GEARS, DOWNLOAD_PLANNING, ENROLL_HARD, ENROLL_SOFT, ENTER_EXTENDED_AVAILABILITITES, EXPORT_FOR_SIGNA, FORCE_WRITE_FT, HAVE_PERSONAL_ACCOUNT, MANAGE_ADMINS, MANAGE_CHARISMA_EVENTS, MANAGE_CONFIG, MANAGE_CONTRIBUTIONS, MANAGE_LOCATION, MANAGE_PERMISSIONS, MANAGE_PERSONAL_ACCOUNTS, MANAGE_SHARED_MEALS, MANAGE_TEAMS, MANAGE_USERS, MUST_SIGN_VOLUNTEER_CHARTER, OFFER_SHARED_MEAL, PAY_CONTRIBUTION, READ_ANIMATION_TO_PUBLISH, READ_FA, READ_FT, READ_GEAR_CATALOG, READ_INVENTORY, READ_SIGNAGE_CATALOG, SEND_MAIL_TEST, SET_FAVORITE_PAGES, SHOTGUN_SHARED_MEAL, SYNC_PLANNING, VALIDATE_FA, VALIDATE_FT, VIEW_DELETED_FT, VIEW_FA_GEAR_DASHBOARD, VIEW_FESTIVAL_EVENTS_STATS, VIEW_GEAR_DASHBOARD, VIEW_LOCATION, VIEW_MULTI_PLANNING, VIEW_ORGA_MOBILE_NAV, VIEW_PLANNING, VIEW_SECURITY_DASHBOARD, VIEW_TIMELINE, VIEW_USEFUL_LINKS, VIEW_VOLUNTEER, VIEW_VOLUNTEER_DETAILS, WRITE_FA, WRITE_FT, WRITE_GEAR_CATALOG, WRITE_INVENTORY, WRITE_SIGNAGE_CATALOG, isPermission, permissions };

//# sourceMappingURL=index.mjs.map